import React, { useEffect } from "react";
import ShareCourseViaBottomSheet from "./components/ShareCourseViaBottomSheet/ShareCourseViaBottomSheet";
import SelectAddressBottomSheet from "./components/SelectAddressBottomSheet/SelectAddressBottomSheet";
import SelectStatesBottomSheet from "./components/SelectStatesBottomSheet/SelectStatesBottomSheet";
import CourseFacultyListBottomSheet from "./components/CourseFacaultyListBottomSheet/CourseFacultyListBottomSheet";
import { useDispatch, useSelector } from "react-redux";
import ExpirySoonBottomSheet from "./components/ExpirySoonBottomSheet/ExpirySoonBottomSheet";
import PaymentProcessingBottomSheet from "./components/PaymentProcessingBottomSheet/PaymentProcessingBottomSheet";
import DueDatePaymentBottomSheet from "./components/DueDatePaymentBottomSheet/DueDatePaymentBottomSheet";
import PaymentFailedBottomSheet from "./components/PaymentFailedBottomSheet/PaymentFailedBottomSheet";
import PaymentSuccessfullBottomSheet from "./components/PaymentSuccessfullBottomSheet/PaymentSuccessfullBottomSheet";
import RunningTightOnBudgetBottomSheet from "./components/RunningTightOnBudgetBottomSheet/RunningTightOnBudgetBottomSheet";
import VideoRestrictionsBottomSheet from "./components/VideoRestrictionsBottomSheet/VideoRestrictionsBottomSheet";
import AboutCourseBottomSheet from "./components/AboutCourseBottomSheet/AboutCourseBottomSheet";
import ViewsExhaustedBottomSheet from "./components/ViewsExhaustedBottomSheet/ViewsExhaustedBottomSheet";
import LikeWhatYouAreWatchingBottomSheet from "./components/LikeWhatYouAreWatchingBottomSheet/LikeWhatYouAreWatchingBottomSheet";
import TestIsLockedBottomSheet from "./components/TestIsLockedBottomSheet/TestIsLockedBottomSheet";
import TestIsTemporarilyLockedBottomSheet from "./components/TestIsTemporarilyLockedBottomSheet/TestIsTemporarilyLockedBottomSheet";
import TestIsTemporarilyLockedTimingBottomSheet from "./components/TestIsTemporarilyLockedTimingBottomSheet/TestIsTemporarilyLockedTimingBottomSheet";
import ApplyCouponBottomSheet from "./components/ApplyCouponBottomSheet/ApplyCouponBottomSheet";
import ApplyBundleBottomSheet from "./components/ApplyBundleBottomSheet/ApplyBundleBottomSheet";
import ApplyBundleReceiptBottomSheet from "./components/ApplyBundleReceiptBottomSheet/ApplyBundleReceiptBottomSheet";
import ContentLockedBottomSheet from "./components/ContentLockedBottomSheet/ContentLockedBottomSheet";
import UpcomingClassModal from "./components/UpcomingClassModal/UpcomingClassModal";
import AnnouncementsAttachments from "./components/AnnouncementsAttachments/AnnouncementsAttachments";
import InstallmentPendingBottomSheet from "./components/InstallmentPendingBottomSheet/InstallmentPendingBottomSheet";
import FullScreenLoader from "@src/components/UIElements/FullScreenLoader";
import PaymentLoader from "@src/components/BottomSheets/components/PaymentLoading";
import RemoveSuggestion from "@src/components/UIElements/Footer/FooterItem/RemoveSuggestion";
import CouponAppliedSuccess from "./components/CouponAppliedSuccess";
import BuyNowSuccess from "./components/BuyNowSuccess";
import PaymentProcessingPopup from "./components/PaymentProcessingPopup";
import PaymentMethods from "./components/PaymentMethodsModal";
import { useTranslation } from "react-i18next";
import CourseAccessRemovedBottomSheet from "./components/CourseAccessRemovedBottomSheet/CourseAccessRemovedBottomSheet";
import { showCourseAccessRemoveBottomSheetAction } from "./store/actions";
import { quitWebviewDeeplink } from "@src/utils/goBack";
import DynamicBundlingBottomSheet from "./components/DynamicBundlingBottomSheet/DynamicBundlingBottomSheet";
import PaymentMethodBottomSheet from "./components/PaymentMethodBottomSheet/PaymentMethodBottomSheet";
import NotSupportedBottomSheet from "./components/NotSupportedBottomSheet/NotSupportedBottomSheet";
import FreeTrialBottomSheet from "./components/FreeTrialBottomSheet/FreeTrialBottomSheet";
import EnrollForFreeCourseBottomSheet from "./components/EnrollForFreeCourseBottomSheet/EnrollForFreeCourseBottomSheet";
import LockedFreeCourseBottomSheet from "./components/LockedFreeCourseBottomSheet/LockedFreeCourseBottomSheet";
import VideoPlayerBottomSheet from "./components/VideoPlayerBottomSheet/VideoPlayerBottomSheet";
import PrepurchageIdfys from "../Tabs/Overview/components/idfys/prepurchageIdfys/PrepurchageIdfys";
import IntroVideoBottomSheet from "./components/IntroVideoBottomSheet/IntroVideoBottomSheet";
const BottomSheets = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    showShareContentViaBottomSheet,
    showAboutThisCourseBottomSheet,
    showVideoRestrictionsBottomSheet,
    showUpcomingLiveClassesBottomSheet,
    showApplyCouponBottomSheet,
    showApplyBundleBottomSheet,
    showApplyBundleReceiptBottomSheet,
    showContentLockedBottomSheet,
    showWhatAreYouWatchingBottomSheet,
    showTestIsLockedBottomSheet,
    showSelectStateBottomSheet,
    showSelectAddressBottomSheet,
    showRunningTightOnBudgetBottomSheet,
    showCongratulationsBottomSheet,
    showDueDateBottomSheet,
    showCourseLockedBottomSheet,
    showPaymentFailedBottomSheet,
    showViewsExhaustedBottomSheet,
    showExpirySoonBottomSheet,
    showPaymentProcessingBottomSheet,
    showTestIsTemporarilyLockedBottomSheet,
    showTestIsTemporarilyLockedTimingBottomSheet,
    showAnnouncementsAttachments,
    showFullScreenLoader,
    showPaymentLoader,
    showRemoveSuggestionsPromt,
    showPaymentProcessingPopup,
    showPaymentMethodsModal,
    showCourseFacultyListBottomSheet,
    showCourseAccessRemoveBottomSheet,
    showDynamicBundlingBottomSheet,
    showNotSupportedBottomsheet,
    showMultiPaymentMethodModal,
    showFreeTrailBottomSheet,
    showEnrollForFreeCourseBottomSheet,
    showLockedFreeCourseBottomSheet,
    showCustomVideoPlayer,
    isIdfysLockContentClicked
  } = useSelector((state) => state.bottomSheetReducer);
  const showIntroVideoBottomSheet = useSelector(
    (state) => state?.bottomSheetReducer?.showIntroVideoBottomSheet == 1 || 0
  );


  const upcomingClass = useSelector(
    (state) => state?.bottomSheetReducer?.showUpcomingLiveClassesBottomSheet
  );

  const showApplyCouponPopup = useSelector(
    (state) => state?.overviewReducer?.showApplyCouponPopup
  );
  const showBuyNowSuccess = useSelector(
    (state) => state?.overviewReducer?.showBuyNowSuccess
  );
  let courseModal = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.courseModal
  );
  useEffect(() => {
    if (courseModal && !courseModal?.hasBuyNow) {
      dispatch(showCourseAccessRemoveBottomSheetAction(true));
    }
  }, [courseModal]);
  return (
    <>
      {showAboutThisCourseBottomSheet && <AboutCourseBottomSheet />}

      {showVideoRestrictionsBottomSheet && <VideoRestrictionsBottomSheet />}
      {showUpcomingLiveClassesBottomSheet && <UpcomingClassModal />}

      {showShareContentViaBottomSheet && <ShareCourseViaBottomSheet />}

      {/* src/components/Tabs/Overview/components/Coupons/index.js  */}
      {showApplyCouponBottomSheet && <ApplyCouponBottomSheet />}
      {showApplyBundleBottomSheet && <ApplyBundleBottomSheet />}
      {showApplyBundleReceiptBottomSheet && <ApplyBundleReceiptBottomSheet />}

      {showWhatAreYouWatchingBottomSheet && (
        <LikeWhatYouAreWatchingBottomSheet />
      )}

      {showTestIsLockedBottomSheet && <TestIsLockedBottomSheet />}

      {showSelectStateBottomSheet && <SelectStatesBottomSheet />}
      {showDynamicBundlingBottomSheet && <DynamicBundlingBottomSheet />}
      {/* {true && <PaymentMethodBottomSheet />} */}
      {showCourseFacultyListBottomSheet && <CourseFacultyListBottomSheet />}

      {showSelectAddressBottomSheet && <SelectAddressBottomSheet />}

      {showRunningTightOnBudgetBottomSheet && (
        <RunningTightOnBudgetBottomSheet />
      )}

      {showCongratulationsBottomSheet && <PaymentSuccessfullBottomSheet />}

      {showDueDateBottomSheet && <DueDatePaymentBottomSheet />}

      {/* course locked */}
      {showContentLockedBottomSheet && <ContentLockedBottomSheet />}

      {isIdfysLockContentClicked && <PrepurchageIdfys />}

      {showPaymentFailedBottomSheet && <PaymentFailedBottomSheet />}

      {showViewsExhaustedBottomSheet && <ViewsExhaustedBottomSheet />}

      {showExpirySoonBottomSheet && <ExpirySoonBottomSheet />}

      {showPaymentProcessingBottomSheet && <PaymentProcessingBottomSheet />}

      {showTestIsTemporarilyLockedTimingBottomSheet && (
        <TestIsTemporarilyLockedTimingBottomSheet />
      )}

      {showTestIsTemporarilyLockedBottomSheet && (
        <TestIsTemporarilyLockedBottomSheet />
      )}
      {showCourseLockedBottomSheet && <InstallmentPendingBottomSheet />}
      {showAnnouncementsAttachments && <AnnouncementsAttachments />}
      {showFullScreenLoader && <FullScreenLoader />}
      {showPaymentLoader && (
        <PaymentLoader
          heading={t(
            "components.bottomSheets.paymentLoader.loaderHeading",
            "Loading"
          )}
          className="Loading"
          button={t("components.bottomSheets.paymentLoader.closeTxt", "Close")}
        >
          {t(
            "components.bottomSheets.paymentLoader.loadingTxt",
            "Please wait while we redirect you to your payment page"
          )}
        </PaymentLoader>
      )}
      {showCourseAccessRemoveBottomSheet && !courseModal?.hasBuyNow && (
        <CourseAccessRemovedBottomSheet
          mainText={courseModal?.heading}
          imageUrl={courseModal?.imageUrl}
          subText={courseModal?.description}
          btnText={"Go Back"}
          btnAction={() => {
            dispatch(showCourseAccessRemoveBottomSheetAction(false));
            quitWebviewDeeplink();
          }}
        />
      )}

      {showRemoveSuggestionsPromt && <RemoveSuggestion />}
      {showApplyCouponPopup && <CouponAppliedSuccess />}
      {showBuyNowSuccess && <BuyNowSuccess />}
      {showPaymentProcessingPopup && <PaymentProcessingPopup />}
      {showPaymentMethodsModal ? <PaymentMethods /> : null}
      {showNotSupportedBottomsheet && <NotSupportedBottomSheet />}
      {showMultiPaymentMethodModal && <PaymentMethodBottomSheet />}
      {showFreeTrailBottomSheet && <FreeTrialBottomSheet />}
      {showEnrollForFreeCourseBottomSheet && <EnrollForFreeCourseBottomSheet />}
      {showLockedFreeCourseBottomSheet && <LockedFreeCourseBottomSheet />}
      {showCustomVideoPlayer && <VideoPlayerBottomSheet />}
      {showIntroVideoBottomSheet && <IntroVideoBottomSheet />}
    </>
  );
};

export default BottomSheets;
